// 混入
const baseMixin = {
    methods: {
        /* 随机获取数组中的数据*/
        // getRandomArrayElements(arr, count) {
        //     var shuffled = arr.slice(0),
        //         i = arr.length,
        //         min = i - count,
        //         temp, index;
        //     while (i-- > min) {
        //         index = Math.floor((i + 1) * Math.random());
        //         temp = shuffled[index];
        //         shuffled[index] = shuffled[i];
        //         shuffled[i] = temp;
        //     }
        //     return shuffled.slice(min);
        // },
        /* 过滤数据 得到特定数据类型 */
        filterDataType(data,dataType){
            for(var item of data){
                if(item['dataType'] == dataType){
                    return item.dataList;
                }
            }
        },
    },
}
export default baseMixin;